import _ from 'lodash';
import { authedFunction } from '../session';
import { getUrl } from './helper';

export const reactionActions = {
  addComment: (entityId, entityType, entityName, site, comment, image, parentId) => {
    const data = {
      entityId,
      entityType,
      entityName,
      site,
      comment,
      parentId,
    };
    if (!_.isEmpty(image)) {
      data.image = image;
    }
    return authedFunction({
      method: 'POST',
      url: getUrl('reactions', 'comments/add'),
      data,
    });
  },
  removeComment: (id) => {
    return authedFunction({
      method: 'POST',
      url: getUrl('reactions', 'comments/remove'),
      data: {
        id,
      },
    });
  },
  getCommentsByThreadId: (threadId, minTime) => {
    const query = {
      threadId,
    };
    if (minTime) {
      query.minTime = minTime;
    }
    return authedFunction({
      method: 'GET',
      url: getUrl('reactions', 'comments/get', query),
    });
  },
  getComments: (entityId, entityType, minTime) => {
    const query = {
      entityId,
      entityType,
    };
    if (minTime) {
      query.minTime = minTime;
    }
    return authedFunction({
      method: 'GET',
      url: getUrl('reactions', 'comments/get', query),
    });
  },
  getSiteComments: (site, limit, minTime) => {
    const query = {
      site,
      limit,
    };
    if (minTime) {
      query.minTime = minTime;
    }
    return authedFunction({
      method: 'GET',
      url: getUrl('reactions', 'comments/get/site', query),
    });
  },
};
